<template>
  <CHeader fixed with-subheader light>
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <img class="icon" alt="Aeru_logo" src="../assets/icons/logo2.png" width="100">
    </CHeaderBrand>
    <CSubheader class="px-3 justify-content-between">
      <CBreadcrumbRouter class="border-0 mb-0"/>
      <CButton class="my-2" color="primary" square size="sm" @click="signOut()">ログアウト</CButton>
    </CSubheader>
  </CHeader>
</template>

<script>

export default {
  name: 'TheHeader',
  components: {
  },
  methods: {
    signOut() {
      localStorage.removeItem('access_token');
      localStorage.setItem('is_auth', false);
      localStorage.removeItem('expired_at');
      this.$router.push('/login')
    }
  },
}
</script>
